import React from 'react'
import { IconAction } from '@olxbr/ds-web'
import { ArrowLeft } from '@olxbr/ds-icons'
import PropTypes from 'prop-types'

const BackButton = ({ onClick, ...props }) => {
  return (
    <div className="flex">
      <IconAction
        onClick={onClick}
        interactive
        icon={<ArrowLeft size={32} />}
        label="Voltar"
        hideVisibleLabel
        {...props}
      />
    </div>
  )
}

BackButton.propTypes = {
  onClick: PropTypes.func.isRequired,
}

export { BackButton }
